import styled from "@emotion/styled";

export const CopilotTitleContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing.xs,
  alignItems: "center",
}));
